<template>
  <div class="col-xs-12 col-md-3">
    <form-group-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="options"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
export default {
  name: "c-protocolo-declaracao-percentual-cursado",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  },
  computed: {
    options() {
      return [
        {
          value: "1",
          text: "Sim"
        },
        {
          value: "0",
          text: "Não"
        }
      ];
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/DeclaracaoPercentualCursado.vue